import React, { useContext } from "react";
import {
  Box,
  IconButton,
  Tooltip
} from "@mui/material";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { genderMap, roleMap, userColumns } from "../../data/userColumn";
import { DataGridPro } from '@mui/x-data-grid-pro';

import api from "../../helper/baseApi";
import { useApiClient } from "../../context/ApiClientContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { DataContext } from ".";
import dayjs from "dayjs";
import CustomToolbar from "../../utils/customToolbar";
import { Edit, Visibility } from "@mui/icons-material";

export default function Listing({ handleShowButton, openAddUserModal, refreshData }) {
  const rows = useContext(DataContext);
  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)} // 👈 navigate with row id
        >
          <Tooltip title="Edit" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,

        // <IconButton sx={{ color: "#39493F" }}>
        //   <Tooltip title="Delete" placement="right">
        //     <Delete />
        //   </Tooltip>
        // </IconButton>,
      ],
    },
    {
      field: "id",
      headerName: "#",
      width: 80,
    },
    {
      field: "code",
      headerName: "Employee Code",
      minWidth: 150,
    },
    {
      field: "name",
      headerName: "Full Name",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "role",
      headerName: "Role",
      minWidth: 150,
      renderCell: (params) => {
        const roleName = roleMap[params.value] || params.value; // fallback if not found
        return (
          <Box
            sx={{
              textTransform: "capitalize",
            }}
          >
            {roleName}
          </Box>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    {
      field: "gender",
      headerName: "Gender",
      minWidth: 150,
      renderCell: (params) => {
        const genderName = genderMap[params.value] || params.value; // fallback if not found
        return (
          <Box
            sx={{
              textTransform: "capitalize",
            }}
          >
            {genderName}
          </Box>
        );
      },
    },
    {
      field: "dob",
      headerName: "Date of Birth",
      minWidth: 150,
      flex: 1,
      type: "date",
      valueGetter: (params) => {
        const value = params;
        return value ? dayjs(value).toDate() : null;

      },
      valueFormatter: (params) => {
        if (!(params instanceof Date) || isNaN(params)) return "";
        return dayjs(params).format("DD-MM-YYYY");
      },
    },
    {
      field: "designation",
      headerName: "Designation",
      minWidth: 200,
    },
    {
      field: "department",
      headerName: "Department",
      minWidth: 150,
    },
    {
      field: "jobGrade",
      headerName: "Job Grade",
      minWidth: 150,
      align: "center",

    },
    //uncomment after the field is added to the json
    {
      field: "reportsToName",
      headerName: "Report To",
      minWidth: 150,
    },

  ];

  const [selectedIds, setSelectedIds] = React.useState([]);
  const navigate = useNavigate();

  const navigateDetails = (id) => {
    navigate(`/view-details/${id}`);
  }

  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const handleDelete = async (ids) => {
    try {
      const apiUrl = `${mobileApiUrl}user/delete`;

      const response = await api.delete(apiUrl, {
        data: { ids: selectedIds }
      });

      if (response.status === 200) {
        toast.success("Rows deleted.");
        refreshData();
      }
    } catch (error) {
      if (error.status === 404 || error.status === 400) {
        toast.error("Oops! Something went wrong.");
      } else {
        toast.error("Something went wrong.");
      }
    }
  };

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === 'include') {
      selectedIds = Array.from(id.ids);
    }
    else if (id.type === 'exclude') {
      const excluded = new Set(id.ids);
      selectedIds = rows.filter(row => !excluded.has(row.id)).map(row => row.id);
    }
    handleShowButton(selectedIds);
  };

  return (
    <div>
      <Box
        style={{
          width: "100%",
          height: "75vh",
          overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
        }}
      >
        <DataGrid
          columns={columns}
          rows={rows}
          showToolbar
          slots={{ 
            toolbar: CustomToolbar,
          }}
          pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 50 },
            },
            sorting: {
              sortModel: [{ field: 'id', sort: 'desc' }],
            },
            columns: {
                columnVisibilityModel: {
                  id: false,
                  email: false,
                  gender: false,
                  dob: false,
                  designation: false,
                },
              },
          }}
          checkboxSelection
          onRowSelectionModelChange={(id) => {
            onSelectedCheckbox(id, rows);
          }}
          disableRowSelectionOnClick
          localeText={{ 
            noRowsLabel: "No records found",
          }}
          slotProps={{
             toolbar: {
              title: ""
            },
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true",
            },
          }}
        />
      </Box>
    </div>
  );
}
